import { Trans } from '@lingui/react/macro';
import { useState } from 'react';

import { Button } from '@/components/buttons';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/Dialog';

type Props = {
  name?: string;
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
};

const UserDeleteDialog = ({ name, open, onClose, onDelete }: Props) => {
  const [isDeleting, setDeleting] = useState(false);

  const handleDelete = () => {
    setDeleting(true);
    onDelete();
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen && !isDeleting) {
      onClose();
    }
  };

  const handleOpenChangeComplete = (isOpen: boolean) => {
    if (!isOpen) {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={handleOpenChange}
      onOpenChangeComplete={handleOpenChangeComplete}
    >
      <DialogContent showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>
            <Trans>Delete User</Trans>
          </DialogTitle>
          <DialogDescription>
            <Trans>
              Are you sure you want to delete <strong>{name}</strong>?
            </Trans>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose
            render={
              <Button size="large" disabled={isDeleting}>
                <Trans>Cancel</Trans>
              </Button>
            }
          />
          <Button
            size="large"
            variant="primary"
            danger
            isLoading={isDeleting}
            onClick={handleDelete}
          >
            <Trans>Yes, Delete</Trans>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UserDeleteDialog;
